// extracted by mini-css-extract-plugin
export default {"Title":"Title_Title__oX1NM","firstText":"Title_firstText__QnmYS"};